module.exports = "/virtual-football-league/img/amblems/left/logos/ALAVES.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/ALAVES.png
// module id = 2049
// module chunks = 4